<script setup lang="ts">
import { toRefs } from 'vue';

import DisciplineIcon from '@/components/DisciplineIcon';

interface Props {
  disciplineCode: string | null;
  serviceProviderName: string;
}

const props = defineProps<Props>();

const { disciplineCode, serviceProviderName } = toRefs(props);
</script>

<template>
  <div class="provider flex h-auto gap-2 p-0 px-2 border-round-md flex-wrap justify-content-start align-items-center">
    <DisciplineIcon v-if="disciplineCode" classes="0" divider-width="0" :code="disciplineCode" :see-code="false" />
    {{ serviceProviderName }}
  </div>
</template>

<style lang="scss">
.provider {
  background-color: #f1f3f3;
  min-height: 25px;
  max-height: 40px;

  .material-icons {
    font-size: 16px;
  }
}
</style>
